"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var React = __importStar(require("react"));

require("./event-message.scss");

var EventMessage = function EventMessage(_a) {
  var message = _a.message;
  return React.createElement("div", {
    className: "event-message"
  }, React.createElement("div", {
    className: "marker"
  }), React.createElement("p", null, message));
};

exports.EventMessage = EventMessage;